module.exports = {
    EstadoProyecto(i){
        switch(parseInt(i))
        {
            case 0:
                return "EN ANÁLISIS";
                break;
            case 1:
                return "DESESTIMADO";
                break;
            case 2:
                return "EN PLAN DE TRABAJO";
                break;
            case 3:
                return "PRESUPUESTANDO";
                break;
            case 4:
                return "PRESUPUESTO RECHAZADO";
                break;
            case 5:
                return "PRESUPUESTO ACEPTADO";
                break;
            case 6:
                return "INFORME CARGADO";
                break;
            case 7:
                return "SIN INFORME";
                break;
            case 8:
                return "CARGANDO DATOS";
                break;
            case 9:
                return "INFORME ENVIADO";
                break;
            case 10:
                return "FACTURANDO";
                break;
            case 11:
                return "FINALIZADO";
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/Proyectos/EstadoEnum.js